import { getEmployeeCustomFields } from './queries/getEmployeeCustomFields';
import { validateEmployeeCustomFields } from './mutations/validateEmployeeCustomFields';
import { updateEmployeeCustomFields } from './mutations/updateEmployeeCustomFields';
import { updateMyCustomFields } from './mutations/updateMyCustomFields';

const queries = {
  getEmployeeCustomFields,
};

const mutations = {
  validateEmployeeCustomFields,
  updateEmployeeCustomFields,
  updateMyCustomFields,
};

export default {
  queries,
  mutations,
};
